import React, { useCallback } from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';

import themes, { THEME_TYPES } from '@Styles/Themes';

import { ACHIEVEMENT_MODAL_KEYS } from '@Services/Editor/Constants';

import { addEmptyAchievement, setAchievementModalStateByType } from '@Services/Editor';

import { ReactComponent as PropertiesAchievementSVG } from '@Assets/Svgs/ic_properties_achievement.svg';
import { ReactComponent as GuideBookSVG } from '@Assets/Svgs/ic_guidebook.svg';
import BottomButton from './BottomButton';

const Bottom = () => {
  const dispatch = useDispatch();
  const achievement = useSelector(({ editor }) => editor?.achievements.achievement);

  const theme = themes[THEME_TYPES.LIGHT];

  const handleAchievementButtonClick = useCallback(() => {
    dispatch(setAchievementModalStateByType({ type: ACHIEVEMENT_MODAL_KEYS.MODAL_VISIBLE }));

    if (!achievement.length) {
      dispatch(addEmptyAchievement());
    }
  }, [achievement, dispatch]);

  const redirectInfo = () => {
    window.open(
      'https://www.notion.so/banjihagames/2fb2b399b5b34e23bb8fcb60684b670e?v=d95334c36ddc4321bfe57a6ff4f93104',
      '_blank',
    );
  };

  return (
    <BottomContainer>
      <BottomButton
        text="업적"
        style={{ userSelect: 'none', MozUserSelect: 'none', msUserSelect: 'none' }}
        Icon={PropertiesAchievementSVG}
        fill={theme.colors.primary}
        onClick={handleAchievementButtonClick}
      />

      <BottomButton
        text="이용 가이드"
        style={{ userSelect: 'none', MozUserSelect: 'none', msUserSelect: 'none' }}
        Icon={GuideBookSVG}
        backgroundColor={theme.colors.ui_3}
        onClick={redirectInfo}
      />
    </BottomContainer>
  );
};

const BottomContainer = styled.div`
  display: flex;
  flex-direction: column;

  margin: 0px -16px -16px -16px;
`;

export default React.memo(Bottom);
